export default "__VITE_ASSET__x5dNmw7___"